var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{key:"block",staticClass:"ctk-skeleton-block tw-relative tw-overflow-hidden tw-rounded-sm",class:[("ctk-skeleton-block__level-" + _vm.level)],style:(Object.assign({}, {width: _vm.width,
      height: _vm.height},
      _vm.background ? { 'background-color': (_vm.background + " !important")} : {}))}):_vm._e(),(!_vm.loading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }